import { createSelector } from 'reselect';

import moment from 'moment';
import prop from 'lodash/fp/prop';

export const isWordCupStarted = createSelector(
  [prop('now'), prop('config')],
  (now, { wordcupStartedDateUTC }) =>
    moment(now) > moment(wordcupStartedDateUTC)
);

export const isBracketStageStarted = createSelector(
  [prop('now'), prop('config')],
  (now, { wordcupBracketStageDateUTC }) =>
    !!wordcupBracketStageDateUTC &&
    moment(now) > moment(wordcupBracketStageDateUTC)
);
